import React, { forwardRef, Ref } from 'react';
import styles from './input_text.module.scss';

type Props = {
  className?: string;
  maxLength?: number;
  placeholder?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  id: string;
  value?: string;
};

export const InputText = forwardRef(
  (
    {
      className = '',
      maxLength = 524288,
      placeholder = '',
      onChange,
      id,
      value,
    }: Props,
    ref: Ref<HTMLInputElement>,
  ) => (
    <input
      ref={ref}
      className={`${styles.input} ${className}`}
      type="text"
      placeholder={placeholder}
      maxLength={maxLength}
      spellCheck={false}
      id={id}
      onChange={onChange}
      value={value}
    />
  ),
);
